import { render, staticRenderFns } from "./UpcomingMaintenancesCard.vue?vue&type=template&id=47a4fcb8&scoped=true&"
import script from "./UpcomingMaintenancesCard.vue?vue&type=script&lang=js&"
export * from "./UpcomingMaintenancesCard.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingMaintenancesCard.vue?vue&type=style&index=0&id=47a4fcb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4fcb8",
  null
  
)

export default component.exports